import { flatMap } from "lodash";

export function getById(stacks, stack_id, element_id) {
  return stacks
    .find(s => s.id === stack_id)
    .elements.find(e => e.id === element_id);
}

function mapType(type) {
  return (
    {
      ccp4_map: "map"
    }[type] || type
  );
}

export function elementFromStackFile(f) {
  const stack = {
    id: f.id,
    type: mapType(f.type),
    url: f.file
  };

  if (f.file_metadata[0]) {
    const d = f.file_metadata[0].data;
    const options = {};
    if (stack.type === "map") {
      options.color = "#1271db";
      options.difference = false;
      options.rmsd = undefined;

      if ("color" in d) options.color = d.color;
      if ("difference" in d) options.difference = d.difference;
      if ("sigma" in d) {
        const rmsd = parseFloat(d.sigma);
        if (!isNaN(rmsd)) {
          options.rmsd = rmsd;
        }
      }
      if (options.rmsd === undefined) {
        options.rmsd = options.difference ? 3.0 : 1.0;
      }
    }
    stack.options = options;
  }
  return stack;
}

export function groupStacksByModelId(stacks) {
  return flatMap(stacks, s => {
    return s.elements
      .filter(e => e.type === "pdb")
      .map(e => {
        return [e.id, e.label, s.name];
      });
  }).reduce((acc, v) => {
    const a = acc.get(v[0]) || { label: v[1], stacks: [] };
    a.stacks.push(v[2]);
    acc.set(v[0], a);
    return acc;
  }, new Map());
}
